export default "/images/3ed8be80913c66110c596ec9d2f1a5a5.avif";